import { render, staticRenderFns } from "./InboundDetail.vue?vue&type=template&id=da362848&scoped=true"
import script from "./InboundDetail.vue?vue&type=script&lang=js"
export * from "./InboundDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da362848",
  null
  
)

export default component.exports